<template>
  <div data-test="in-this-way-extra" class="mt-2 ml-6">
    <m-radio-item
      :id="`option-${extra.label}`"
      :option="{ value: () => extra.label }"
      :modelValue="value"
      @change="handleExtra"
    />
    <div
      v-if="extra.label === value && extra.input === 'accounts' && extra.type === 'percentage'"
      class="mt-2 flex flex-col space-y-2 bg-gray-100 border rounded p-2"
    >
      <div v-for="(account, idx) in localAccounts" :key="idx">
        <p class="text-sm font-bold">{{ account.member.name }}</p>
        <label :for="`extra-input-${idx}`" class="text-sm text-gray-600">
          <span class="font-semibold">Identifier:</span>
          {{ account.identifier }} ( Tax Free {{ account.taxFree | percent }})
        </label>
        <m-input-percentage
          v-model="account.value"
          :id="`extra-input-${idx}`"
          class="w-full"
        />
      </div>
      <p class="font-bold text-sm text-right">Total: {{total}} %</p>
    </div>
    <div
      v-if="extra.label === value && extra.input === 'accounts' && extra.type === 'order'"
      class="mt-2 flex flex-col bg-gray-100 border rounded p-2 space-y-2"
    >
      <div
        v-for="(account, idx) in localAccounts"
        :key="idx"
        class="flex space-x-2 items-center"
      >
        <div class="flex flex-col">
          <button
            class="flex justify-center focus:outline-none"
            @click="handleUp(idx)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 15l7-7 7 7"
              />
            </svg>
          </button>
          <button
            class="flex justify-center focus:outline-none"
            @click="handleDown(idx)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>
        </div>
        <p class="text-sm text-gray-600">
          <span class="font-semibold">
            {{ account.member.name }}
          </span>
          {{ account.identifier }} ( Tax Free {{ account.taxFree | percent }})
        </p>
      </div>
    </div>
    <div v-if="$slots.error" class="mt-1 text-red-500 text-sm text-right">
      <slot name="error"></slot>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { arrayMove } from '@/app/utils/utils';

export default {
  name: 'in-this-way-extra',
  props: {
    extra: {
      type: Object,
      default: () => ({}),
    },
    members: {
      type: Object,
      default: () => ({}),
    },
    accounts: {
      type: Array,
      default: () => ([]),
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      localAccounts: [],
    };
  },
  computed: {
    total() {
      return Math.round(this.localAccounts.reduce((total, curr) => total + +curr.value, 0));
    },
  },
  methods: {
    handleExtra(e) {
      this.$emit('input', e);
    },
    handleUp(idx) {
      if (idx === 0) return;
      this.localAccounts = arrayMove(this.localAccounts, idx, idx - 1);
    },
    handleDown(idx) {
      if (idx + 1 === this.localAccounts.length) return;
      this.localAccounts = arrayMove(this.localAccounts, idx, idx + 1);
    },
  },
  watch: {
    localAccounts: {
      deep: true,
      handler(e) {
        this.$emit('accounts', e);
      },
    },
  },
  beforeMount() {
    if (this.accounts.length > 0) {
      // Edit Rule
      this.localAccounts = this.accounts;
    } else {
      // Add Rule
      _.forEach(this.members, (member) => {
        this.localAccounts.push(..._.values(member.accounts).map(account => ({
          member,
          ...account,
        })));
      });
    }
  },
};
</script>
